import { customAxios as axios, getToken } from '../../../request'
import { apiUrl } from '../../../settings'

export const addSubscriptionActivityUrl = () => {
  return apiUrl + '/addGeneralSubscriptionActivity'
}

export const updateInvoiceStatusUrl = () => {
  return apiUrl + '/updateInvoiceStatus'
}

export const allGeneralSubscriptionUrl = () => {
  return apiUrl + '/allGeneralSubscription'
}

export const getSingleGeneralSubscriptionByIdUrl = () => {
  return apiUrl + '/api/getSingleGeneralSubscriptionById'
}

export const addCourierUrl = () => {
  return apiUrl + '/addCourierDetails'
}

// New Edit Functions :-
export const updateGeneralDetailsApi = async (id, data) => {
  const url = `${apiUrl}/generalSubscription/${id}`
  try {
    let { data: response } = await axios.put(url, data, getToken())
    return { error: false, result: response }
  } catch (error) {
    return { error: true, message: error }
  }
}

export const updatePaymentApi = async (data) => {
  const url = `${apiUrl}/edit-payment`
  try {
    let { data: response } = await axios.post(url, data, getToken())
    return { error: false, result: response }
  } catch (error) {
    return { error: true, message: error }
  }
}

export const updateCourierApi = async (data) => {
  const url = `${apiUrl}/edit-courier`
  try {
    let { data: response } = await axios.post(url, data, getToken())
    return { error: false, result: response }
  } catch (error) {
    return { error: true, message: error }
  }
}
export const sendInvoiceReminderUrl = () => {
  const url = `${apiUrl}/invoice/send-reminder`
  return url
}

export const mailInvoiceUrl = (invoiceId) => {
  return `${apiUrl}/api/invoice/mail/${invoiceId}`
}

export const mailReceiptUrl = (paymentId) => {
  return `${apiUrl}/api/receipt/mail/${paymentId}`
}
